import React, { useState, useEffect } from 'react';

// Amplify
import { graphqlOperation, API } from 'aws-amplify';

// Components
import { Table } from 'antd';

// Mock
// import AddItem from './AddItem';
// import EditItem from './EditItem';
import { Link } from 'react-router-dom';
import { Contract, IConnectListQuery, ContractStatus } from '../../types';
import { History } from 'history';
import withAppState, { IAppStateComponentProps } from '../../state/withAppState';
import { ApiInfiniteTable } from 'basealpha-ui';
import moment from 'moment';

class ContractTable extends ApiInfiniteTable<Contract> {}

type Props = IAppStateComponentProps & { status: ContractStatus; history: History };
const List = (props: Props): React.ReactElement => {
  const dataSource = async (page: number | null, pageSize?: number): Promise<{ data: Contract[]; count: number }> => {
    return (await API.get('EhcmsPortalApi', '/customer/contracts', {
      queryStringParameters: {
        page,
        pageSize,
        status: props.status,
      },
    })) as { data: Contract[]; count: number };
  };

  const columns = [
    {
      title: 'Contractor',
      dataIndex: 'employee',
      key: 'employee',
      render: (text: string, record: Contract): string => {
        return record.employee_id[1];
      },
    },
    {
      title: 'Position',
      dataIndex: 'job',
      key: 'job',
      render: (text: string, record: Contract): string => {
        return record.job_id[1];
      },
    },
    {
      title: 'Start Date',
      dataIndex: 'date_start',
      key: 'date_start',
      render: (text: string, record: Contract): string => {
        return record.date_start && moment(record.date_start).format('MMMM Do, YYYY');
      },
    },
    {
      title: 'End Date',
      dataIndex: 'date_end',
      key: 'date_end',
      render: (text: string, record: Contract): string => {
        return record.date_end && moment(record.date_end).format('MMMM Do, YYYY');
      },
    },
  ];
  return (
    <React.Fragment>
      <br />
      <ContractTable
        tableId="contract-table"
        onRowClick={(record: Contract, rowIndex: number): void => {
          props.history.push(`/contractors/${record.id}`, { record });
        }}
        columns={columns}
        dataFetcher={dataSource}
      />
    </React.Fragment>
  );
};

export default withAppState(List);
